import { useMutation, useQueryClient } from "@tanstack/react-query";

import { supabase } from "@/shared/lib/supabase";
import { useAuth } from "@/shared/hooks/useAuth";
import { useAppContext } from "@/shared/hooks/useAppContext";

interface ReactivateTpaParams {
  signatureType: "tpa" | "irs";
}

export function useReactivateTPA() {
  const queryClient = useQueryClient();
  const { user: authUser } = useAuth();
  const { person } = useAppContext();

  return useMutation({
    mutationFn: async ({ signatureType }: ReactivateTpaParams) => {
      const { data, error } = await supabase.functions.invoke("legal/tpa/reactivate", {
        body: {
          signatureType,
          estateId: person?.estate_id,
        },
      });

      if (error) throw error;
      return data as { success: boolean; message: string };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["userSettingsSupabase", authUser?.sub] });
    },
  });
}
